import { BreadCrumb } from 'primereact/breadcrumb'
import { useEffect, useState } from 'react'
import { ROUTE_PATH } from '../../constant/urlConstant'
import MzTable from '../../common/MzTable'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import ErrorPage from '../../common/Error'
import { Calendar } from 'primereact/calendar'
import { Sidebar } from 'primereact/sidebar'
import { AutoComplete } from 'primereact/autocomplete'
import useIsMobile from '../../common/MobileDeviceHook'
import moment from 'moment'
const UserComponent = (props) => {
  const [openFilterTab, setFilterTab] = useState(null)
  const { reset } = useForm({})
  const isMobile = useIsMobile()
  const [paginationInfo, setPaginationInfo] = useState({
    pageSize: 10,
    pageNumber: 0,
    totalRecords: 0,
    totalPages: 0
  })
  const {
    userList,
    isPageLevelError,
    isLoading,
    userTableData,
    handleOnReadRecord,
    handleOnDeleteRecord,
    handleOnEditRecord,
    handleOnCreatedRecord,
    fetchUserList
  } = props.userProps

  const history = useNavigate()
  const shouldRenderFullPageError = () => isPageLevelError
  const shouldRenderUserTransactionList = () =>
    userTableData?.tableData?.columns?.length > 0
  const shouldRenderNotFoundView = () =>
    !shouldRenderFullPageError && !shouldRenderUserTransactionList
  const [query, setQuery] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [startDateValue, setStartDateValue] = useState(null)
  const [endDateValue, setEndDateValue] = useState(null)
  const [suggestions] = useState([])
  const formatedUTCDate = (date, isEndDate = false) => {
    if (!date) return null
    const dateObj = new Date(date)
    if (isEndDate) {
      dateObj.setHours(23, 59, 59, 999)
    } else {
      dateObj.setHours(0, 0, 0, 0)
    }
    const year = dateObj.getFullYear()
    const month = dateObj.getMonth()
    const day = dateObj.getDate()
    const hours = dateObj.getHours()
    const minutes = dateObj.getMinutes()
    const seconds = dateObj.getSeconds()
    const milliseconds = dateObj.getMilliseconds()
    const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds))

    const result = utcDate.toISOString()
    return result
  }

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.value
    setStartDateValue(selectedStartDate)

    if (selectedStartDate) {
      const formattedStartDate = formatedUTCDate(selectedStartDate, false)
      setStartDate(formattedStartDate)
    } else {
      setStartDate(null)
      setEndDateValue(null)
      setEndDate(null)
    }
  }

  const handleEndDateChange = (e) => {
    const selectedEndDate = e.value
    setEndDateValue(selectedEndDate)

    if (selectedEndDate) {
      setEndDate(formatedUTCDate(selectedEndDate, true))
    } else {
      setEndDate(null)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.length > 3 || query === '') {
        const payload = {
          query,
          pageNumber: 0,
          pageSize: 10
        }
        if (startDate && endDate) {
          payload.startDate = startDate
          payload.endDate = endDate
        }
        fetchUserList(payload)
      }
    }, 300)

    return () => clearTimeout(delayDebounceFn)
  }, [query, fetchUserList, startDate, endDate])

  const filters = {
    global: { value: null },
    userName: { filterKey: 'username', value: null },
    email: { filterKey: 'email', value: null }
  }

  const loadLazyData = (event) => {
    const { pageNumber, pageSize } = event

    setPaginationInfo({
      pageNumber,
      pageSize
    })

    fetchUserList({
      query: query,
      startDate: startDate,
      endDate: endDate,
      pageNumber,
      pageSize
    })
  }

  const tableProps = {
    // value: userList?.content ?? [],
    value:
      userList?.content?.map((user) => ({
        ...user,
        createdAt: (() => {
          const utcMoment = moment.utc(user.createdAt)
          const localMoment = moment(user.createdAt)
          return `${utcMoment.format('DD/MMM/YYYY')} ${localMoment.format('HH:mm')}`
        })()
      })) ?? [],
    loading: isLoading,
    columns: userTableData?.tableData?.columns,
    paginationInfo: {
      ...paginationInfo,
      totalRecords: userList?.totalElements ?? 0
    },

    screenPermission: userTableData?.tableData?.screenPermission,
    loadLazyData,
    emptyMessage: 'No User Record Found',
    filters,
    sortField: null,
    showMoreAction: false,
    onReadRecord: handleOnReadRecord,
    onEditRecord: handleOnEditRecord,
    onDeleteRecord: handleOnDeleteRecord
  }

  const handleToCreateUser = () => {
    handleOnCreatedRecord()
  }

  const renderPageHeaderSection = () => {
    const breadCrumbItems = [
      { label: 'User', command: () => history(ROUTE_PATH.USER.ADD) }
    ]
    const home = {
      icon: 'pi pi-home',
      command: () => history(ROUTE_PATH.DASHBOARD.HOME)
    }
    const handleFilterClick = () => {
      setFilterTab(true)
    }



    return (
      <div className="flex justify-content-between align-items-center border-1 border-200 border-round bg-white">
        <BreadCrumb model={breadCrumbItems} home={home} className="border-0" />
        <div className="mr-2 flex justify-content-between h-full align-items-center gap-3">
          <div className="flex" style={{ maxWidth: '600px' }}>
            <div className="mr-2 mt-2 md:mr-3">
              <i
                className="pi pi pi-filter text-green-400 text-2xl cursor-pointer"
                onClick={handleFilterClick}
              ></i>
            </div>
          </div>
          <div>
            <Button onClick={() => handleToCreateUser()} className="py-2">
              Add User
            </Button>
          </div>
        </div>
      </div>
    )
  }

  const handleCloseFilter = () => {
    if (isMobile) {
      setFilterTab(false)
    } else {
      setFilterTab(false)
      setQuery('')
      setStartDateValue(null)
      setEndDateValue(null)
      setStartDate(null)
      setEndDate(null)
    }
  }


  const handleCloseFilterMobile = () => {
    setFilterTab(false)
  }

  const handleReset = () => {
    setQuery('')
    setStartDateValue(null)
    setEndDateValue(null)
    setStartDate(null)
    setEndDate(null)
    reset({
      district: '',
      taluka: '',
      village: ''
    })
  }

  return (
    <div>
      <div className=" ">
        {renderPageHeaderSection()}
        {shouldRenderFullPageError() && (
          <div>
            <ErrorPage />
          </div>
        )}
        {openFilterTab && !isMobile && (
          <div className=" flex justify-content-end gap-2 h-5 w-full bg-white shadow-2 border-0 border-200 border-round bg-white mt-2">
            <div className="w-12rem mt-1 p-1">
              {' '}
              <Calendar
                value={startDateValue}
                onChange={handleStartDateChange}
                readOnlyInput
                placeholder="Select Start Date"
                showIcon
                showButtonBar
                dateFormat="dd/mm/yy"
                maxDate={new Date()}
              />
            </div>
            <div className="w-12rem mt-1 p-1">
              {' '}
              <Calendar
                value={endDateValue}
                onChange={handleEndDateChange}
                readOnlyInput
                placeholder="Select End Date"
                showIcon
                showButtonBar
                dateFormat="dd/mm/yy"
                maxDate={new Date()}
                disabled={!startDateValue}
                minDate={startDateValue}
              />
            </div>
            <div className="mb-2 w-10rem mt-1 p-1">
              <AutoComplete
                value={query}
                suggestions={suggestions}
                field="label"
                onChange={(e) => setQuery(e.value)}
                dropdown
                placeholder="Search User..."
              />
            </div>
            <div className="mt-2 p-2">
              {' '}
              <i
                className="pi pi-times-circle text-red-500 text-2xl cursor-pointer"
                onClick={handleCloseFilter}
              ></i>
            </div>
          </div>
        )}


        {openFilterTab && isMobile && (
          <Sidebar
            visible={openFilterTab}
            position="bottom"
            onHide={handleCloseFilterMobile}
            className="p-sidebar-md"
            dismissable={false}
            modal={false}
          >
            <div className="grid p-fluid">
              <div className="mb-2 w-25rem mt-1 p-1">
                <div className="p-inputgroup">
                  <AutoComplete
                    value={query}
                    suggestions={suggestions}
                    field="label"
                    onChange={(e) => setQuery(e.value)}
                    dropdown
                    placeholder="Search User..."
                  />
                </div>
              </div>
              <div className="grid mt-1 w-full">
                <div className="col-6 p-1">
                  <Calendar
                    value={startDateValue}
                    onChange={handleStartDateChange}
                    readOnlyInput
                    placeholder="Select Start Date"
                    showIcon
                    showButtonBar
                    dateFormat="dd/mm/yy"
                    maxDate={new Date()}
                    className="w-full"
                  />
                </div>
                <div className="col-6 p-1">
                  <Calendar
                    value={endDateValue}
                    onChange={handleEndDateChange}
                    readOnlyInput
                    placeholder="Select End Date"
                    showIcon
                    showButtonBar
                    dateFormat="dd/mm/yy"
                    maxDate={new Date()}
                    disabled={!startDateValue}
                    minDate={startDateValue}
                    className="w-full"
                  />
                </div>
              </div>


            </div>
            <div className="mt-4 p-1 flex justify-content-center align-items-center gap-3">
              <Button onClick={handleReset} className="w-10rem flex justify-content-center">
                Reset
              </Button>
              <Button onClick={() => setFilterTab(false)} className="w-10rem flex justify-content-center" severity="secondary">
                Close
              </Button>
            </div>
          </Sidebar>
        )}


        {shouldRenderUserTransactionList() && (
          <div className="border-1 border-200 border-round mt-3 p-2 bg-white">
            <MzTable {...tableProps} />
          </div>
        )}
        {shouldRenderNotFoundView() && <div>No record to show</div>}
      </div>
    </div>
  )
}
export default UserComponent
